import { createFileRoute } from "@tanstack/react-router";
import { OperationDashboardPage } from "@/components/dashboard/OperationDashboard";

export const Route = createFileRoute("/")({
  head: () => ({ meta: [{ title: "Dashboard de Operación — LicitaPro" }] }),
  component: OperationDashboardPage,
});
